import { cn } from '@/utils';

function ErrorMessage({ children, className, ...props }) {
	return (
		<p
			className={cn('mt-[5px] text-xs text-red', className)}
			role="alert"
			{...props}
		>
			{children}
		</p>
	);
}

export default ErrorMessage;
